import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/services/it/erp/page.tsx");
